import { render, staticRenderFns } from "./Outsourcer.vue?vue&type=template&id=5b91dc17&scoped=true&"
import script from "./Outsourcer.vue?vue&type=script&lang=js&"
export * from "./Outsourcer.vue?vue&type=script&lang=js&"
import style0 from "./Outsourcer.vue?vue&type=style&index=0&id=5b91dc17&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b91dc17",
  null
  
)

export default component.exports